// extracted by mini-css-extract-plugin
export default {"headerActions":"isni-more-info-page_headerActions__fDGnc","button":"isni-more-info-page_button__cj7lJ","isniValue":"isni-more-info-page_isniValue__gBuPQ"};